"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OverviewContent = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _variables = require("../../constants/variables");
var _useCatalogueUrlAndId = require("../../hooks/useCatalogueUrlAndId");
var _useOverviewContext = require("../../hooks/useOverviewContext");
var _usePageNumberContext = require("../../hooks/usePageNumberContext");
var _utils = require("../../utils");
var _OverviewButton = require("../OverviewButton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const OverviewContent = ()=>{
    const { catalogueUrl } = (0, _useCatalogueUrlAndId.useCatalogueUrlAndId)();
    const { isOverviewOpen } = (0, _useOverviewContext.useOverviewContext)();
    const { totalPageCount } = (0, _usePageNumberContext.usePageNumberContext)();
    const { getTestId } = (0, _testidGenerator.default)();
    const contentRef = (0, _react.useRef)(null);
    const pageThumbnails = (0, _react.useMemo)(()=>catalogueUrl ? (0, _utils.generateImageUrls)(catalogueUrl, totalPageCount, 'Normal') : [], [
        catalogueUrl,
        totalPageCount
    ]);
    (0, _react.useEffect)(()=>{
        if (isOverviewOpen) {
            var _contentRef_current;
            (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.focus();
        }
    }, [
        isOverviewOpen
    ]);
    if (!((0, _utils.isDefined)(catalogueUrl) && pageThumbnails.length > 0)) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        ref: contentRef,
        "data-testid": getTestId(_variables.OVERVIEW_CONTENT_ELEMENT_ID),
        id: _variables.OVERVIEW_CONTENT_ELEMENT_ID,
        tabIndex: -1,
        children: pageThumbnails.map((param)=>{
            let { imageUrl, pageNumber } = param;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OverviewButton.OverviewButton, {
                imageUrl: imageUrl,
                pageNumber: pageNumber
            }, imageUrl);
        })
    });
};
exports.OverviewContent = OverviewContent;
